import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-black text-white px-4 py-12 font-sans">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
        <p className="mb-4 text-gray-300">Your privacy is important to us. This Privacy Policy explains how CQZ Entertainments LLP ("we", "our", or "us") collects, uses, and protects your information when you use our entertainment, gaming, and money-earning platform, including our website and mobile application.</p>
        <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
        <ul className="list-disc ml-6 mb-4 text-gray-300">
          <li>Personal Information: Name, email address, phone number, and other details you provide during registration or while using our services.</li>
          <li>Usage Data: Information about how you interact with our quizzes, games, and payment features.</li>
          <li>Device Information: Device type, operating system, and unique device identifiers.</li>
        </ul>
        <h2 className="text-xl font-semibold mt-8 mb-2">2. How We Use Your Information</h2>
        <ul className="list-disc ml-6 mb-4 text-gray-300">
          <li>To provide, maintain, and improve our entertainment and gaming services.</li>
          <li>To process payments, rewards, and transactions securely.</li>
          <li>To personalize your experience and recommend relevant quizzes, games, and offers.</li>
          <li>To communicate with you about updates, promotions, and support.</li>
        </ul>
        <h2 className="text-xl font-semibold mt-8 mb-2">3. Sharing Your Information</h2>
        <ul className="list-disc ml-6 mb-4 text-gray-300">
          <li>We do not sell your personal information to third parties.</li>
          <li>We may share information with trusted partners for payment processing, analytics, and legal compliance.</li>
        </ul>
        <h2 className="text-xl font-semibold mt-8 mb-2">4. Data Security</h2>
        <p className="mb-4 text-gray-300">We use industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure.</p>
        <h2 className="text-xl font-semibold mt-8 mb-2">5. Children’s Privacy</h2>
        <p className="mb-4 text-gray-300">Our platform is not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>
        <h2 className="text-xl font-semibold mt-8 mb-2">6. Changes to This Policy</h2>
        <p className="mb-4 text-gray-300">We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.</p>
        <h2 className="text-xl font-semibold mt-8 mb-2">7. Contact Us</h2>
        <p className="mb-4 text-gray-300">If you have any questions about this Privacy Policy, please contact us at cqzentertainments@gmail.com.</p>
      </div>
    </div>
  );
} 